var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "all_form_block", attrs: { "data-name": "achievement" } },
    [
      _c("div", { staticClass: "block" }, [
        _c(
          "div",
          { staticClass: "name_tools", attrs: { id: "cv-achievement" } },
          [_vm._v(_vm._s(_vm.$store.getters.cv_t("achievement")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "all_form" },
          [
            _c("br"),
            _vm._v(" "),
            _c("switch-button", {
              model: {
                value: _vm.$store.state.cv.hasAchievement,
                callback: function($$v) {
                  _vm.$set(_vm.$store.state.cv, "hasAchievement", $$v)
                },
                expression: "$store.state.cv.hasAchievement"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "inp_info" }, [
              _c("div", { staticClass: "div_relative" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.$parent.correctLabel($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.cv_t("achievement")))]
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.$store.state.cv.achievement,
                      expression: "$store.state.cv.achievement",
                      modifiers: { trim: true }
                    }
                  ],
                  domProps: { value: _vm.$store.state.cv.achievement },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.$store.state.cv,
                          "achievement",
                          $event.target.value.trim()
                        )
                      },
                      function($event) {
                        return _vm.$parent.correctLabel($event)
                      }
                    ],
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      ) {
                        return null
                      }
                      return _vm.$parent.correctLabel($event)
                    },
                    click: function($event) {
                      return _vm.$parent.correctLabel($event)
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ])
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-380db7fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-380db7fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/tools-components/achievement.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-380db7fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/tools-components/achievement.vue
// module chunks = 0